import React from 'react'
import Module from '~/components/Module'
import SVG from '~/components/SVG'
import TextToggle from '~/components/TextToggle'
import introduceIcon from '~/assets/icon-introduce.svg'
import styles from './index.css'

const ActivityIntroduce = props => {
  const { description } = props

  if (!description) {
    return null
  }

  return (
    <Module
      headerIcon={<SVG src={introduceIcon} width={12} height={11} />}
      className={styles.activityIntroduce}
      headerText="活动介绍"
    >
      <TextToggle
        className={styles.activityIntroduceContent}
        content={description}
        minLength={200}
      />
    </Module>
  )
}

export default ActivityIntroduce



// WEBPACK FOOTER //
// ./src/modules/ActivityIntroduce/index.js